import { Injectable } from '@angular/core';
import {LoaderService} from '@app/core/services/loader/loader.service';
import {NotificationService} from '@app/core/services/notification/notification.service';

@Injectable({
  providedIn: 'root'
})
export class HandleApiService {

  constructor( private loaderService: LoaderService,
               private notification: NotificationService) {
  }

  handleApi( title = '', msg401Error = 'Invalid') {
    return (res: any) => {
      if (res.StatusCode === 401) {
        this.notification.error(msg401Error, title);
        this.loaderService.hide();
      } else if (res.StatusCode === 400 || res.StatusCode === 203) {
        this.notification.error(res.Message, 'Error');
        this.loaderService.hide();
      } else if (res.StatusCode === 500) {
        this.notification.error('An error occured. Try again', 'Error');
        this.loaderService.hide();
      } else {
        this.loaderService.hide();
      }
      return res;
    };
  }
}
